import React from 'react';
import { connect } from 'react-redux';

// styles
import './ConsumptionDetailMenu.Styles.css';

// import functions 
import * as ComponentFunctions from './ConsumptionDetailMenu.Functions';
import { Button, Tooltip } from '@fluentui/react-components';
import { ChevronDoubleRight20Regular, ChevronRight20Regular } from '@fluentui/react-icons';



const ConsumptionDetailMenu = (props: ComponentFunctions.Props) => {

    const dispatchChangeStatus = (setAll: boolean) => {
        props.ChangeStatus(props.ProtocolId, props.ProtocolConsumptionId, 5, setAll);
    }


    return (
        <div className="consumption-detail-menu-container">
            <Tooltip content="Ignorar este consumo" relationship="label">
                <Button appearance="subtle" onClick={() => dispatchChangeStatus(false)} icon={<ChevronRight20Regular />}>Ignorar</Button>
            </Tooltip>
            <Tooltip content="Ignorar todos los consumos de este tipo" relationship="label">
                <Button appearance="outline" onClick={() => dispatchChangeStatus(true)} icon={<ChevronDoubleRight20Regular />}>Ignorar todos</Button>
            </Tooltip>
        </div>
    );
};

export default connect (
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
) (ConsumptionDetailMenu as any);